module.exports = __webpack_public_path__ + "img/grey.8a4d8ef.svg";